import { useEffect, useState } from 'react';
import { WifiOff, Wifi } from 'lucide-react';
import { toast } from 'sonner';

/**
 * Visible top banner when the browser loses internet.
 * Also surfaces a toast on disconnect / reconnect so users
 * never see misleading "no permission" errors that are really network failures.
 */
const NetworkStatus = () => {
  const [online, setOnline] = useState(
    typeof navigator !== 'undefined' ? navigator.onLine : true
  );

  useEffect(() => {
    const goOnline = () => {
      setOnline(true);
      toast.success('عاد الاتصال بالإنترنت');
    };
    const goOffline = () => {
      setOnline(false);
      toast.error('لا يوجد اتصال بالإنترنت');
    };
    window.addEventListener('online', goOnline);
    window.addEventListener('offline', goOffline);
    return () => {
      window.removeEventListener('online', goOnline);
      window.removeEventListener('offline', goOffline);
    };
  }, []);

  if (online) return null;

  return (
    <div className="fixed top-0 left-0 right-0 z-[200] flex items-center justify-center gap-2 bg-destructive text-destructive-foreground px-3 py-1.5 text-sm shadow-md">
      <WifiOff className="h-4 w-4" />
      <span>لا يوجد اتصال بالإنترنت — لن يتم حفظ التغييرات حتى يعود الاتصال</span>
    </div>
  );
};

export default NetworkStatus;
